import { render } from "./AppGuestShell.vue?vue&type=template&id=4af345db&scoped=true&lang=pug"
import script from "./AppGuestShell.vue?vue&type=script&lang=js"
export * from "./AppGuestShell.vue?vue&type=script&lang=js"

import "./AppGuestShell.vue?vue&type=style&index=0&id=4af345db&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af345db"]])

export default __exports__